import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { glossary } from '#src/lib/glossary.ts';
import { useCommonGameSet, useIsSupportedCardSet } from '#src/set/index.ts';

import type { CardSetLabel_cardSet } from './__generated__/index.graphql.ts';

type Props = {
  cardSet: Nullable<CardSetLabel_cardSet>;
};

const ACTIVE_SET_STYLE: React.CSSProperties = {
  background:
    'linear-gradient(315deg, var(--c-set-main-color) 14.64%, #e8ecee 85.36%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
};

export const CardSetLabel = ({ cardSet }: Props) => {
  const isSupportedCardSet = useIsSupportedCardSet();
  const commonGameSet = useCommonGameSet();

  if (!cardSet) {
    return null;
  }

  const styleMap = {
    [commonGameSet.cardSet.baseSlug]: {},
    [commonGameSet.cardSet.activeSlug]: ACTIVE_SET_STYLE,
  };

  return (
    <span
      style={isSupportedCardSet(cardSet.slug) ? styleMap[cardSet.slug] : {}}
    >
      <FormattedMessage
        {...glossary.setEdition}
        values={{
          set: cardSet.name,
        }}
      />
    </span>
  );
};

CardSetLabel.fragments = {
  cardSet: gql`
    fragment CardSetLabel_cardSet on CardSet {
      slug
      name
    }
  ` as TypedDocumentNode<CardSetLabel_cardSet>,
};
